export default __webpack_public_path__ + "images/NJ.27b6cba.png";